import { render, staticRenderFns } from "./caseDetailTemp.vue?vue&type=template&id=0a5dc2e2&scoped=true&"
import script from "./caseDetailTemp.vue?vue&type=script&lang=js&"
export * from "./caseDetailTemp.vue?vue&type=script&lang=js&"
import style0 from "./caseDetailTemp.vue?vue&type=style&index=0&id=0a5dc2e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5dc2e2",
  null
  
)

export default component.exports